import { Component, Vue } from 'vue-property-decorator';
import ChannelBar from '@/components/layout/ChannelBar.vue';
import ChannelMessageSubscription from '@/graphql/subscriptions/ChannelMessageCreated.gql';
import { ChannelFields } from '@/types/graphql/schemaTypes';

const CHANNEL_LIMIT = 3;
@Component({
  apollo: {
    $subscribe: {
      channelMessage: {
        query: ChannelMessageSubscription,
        variables() {
          return {
            shipmentId: this.$route.params.id
          };
        },
        result({ data }) {
          // when receiving a new message open the channel is closed
          this.openChannel(data.channelMessageCreated.channel.id);
          // on next tick send new message on bus to make sure the message receivable by the cannel
          this.$nextTick(() => {
            this.$root.$emit('channelMessageCreated', data.channelMessageCreated);
          });
        }
      }
    }
  },
  components: {
    ChannelBar
  }
})
export default class channelsMixin extends Vue {
  openedChannels: string[] = [];

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  render() {}

  reopenChannel(channels: ChannelFields[]) {
    channels.forEach((channel) => {
      if (sessionStorage.getItem(`channel-${channel.id}-status`) &&
          !this.openedChannels.includes(channel.id)) {
        this.openedChannels.push(channel.id);
      }
    });
  }

  openChannel(id: string) {
    if (!this.openedChannels.includes(id)) {
      if (this.openedChannels.length >= CHANNEL_LIMIT) {
        const firstId = this.openedChannels[0];
        sessionStorage.removeItem(`channel-${firstId}-status`);
        this.openedChannels.shift();
      }
      this.openedChannels.push(id);
    }
    sessionStorage.setItem(`channel-${id}-status`, 'opened');
  }
}
